import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import Modal from "../Modal";
import Carousel from "../Carousel";
import Button from "wonderbly-components/lib/Button";
import { prismicImage } from "src/common/utils/prismic-image";

import "./Highlights.scss";

const Highlights = (props) => {
  if (!props.ctaText || isEmpty(props.slides)) {
    return null;
  }

  return (
    <div className="Highlights">
      <Button onClick={props.handleOpenModal}>{props.ctaText}</Button>
      <Modal className="Highlights__modal" isOpen={props.isOpen} default>
        <div className="Highlights__modal-inner">
          <div className="Highlights__modal-header">
            <Button
              className="Highlights__modal__btn--cancel"
              onClick={props.handleCloseModal}
              unstyled
            >
              Close
            </Button>
          </div>
          <div className="Highlights__carousel">
            <Carousel externalNavigation>
              {props.slides.map((slide, idx) => (
                <div key={idx} className="Highlights__slide">
                  <div className="Highlights__slide-inner">
                    <img
                      className="Highlights__slide__image"
                      src={prismicImage(slide.image)}
                      alt={slide.image.alt || ""}
                    />
                    <div className="Highlights__slide__content">
                      {slide.subtitle && (
                        <h4 className="Highlights__subtitle">
                          {slide.subtitle}
                        </h4>
                      )}
                      <h3 className="Highlights__title">{slide.title}</h3>
                      {slide.description && (
                        <p className="Highlights__description">
                          {slide.description}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </Modal>
    </div>
  );
};

Highlights.propTypes = {
  ctaText: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  handleOpenModal: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

export default Highlights;
